(function () {
  'use strict';

  // Kindle models, in dropdown order. "handle" = collection handle (/collections/<handle>).
  // !! Check these handles against your real Kindle collections (Shopify admin > Collections).
  var MODELS = [
    { label: 'Kindle Paperwhite (12th Gen)', handle: 'kindle-paperwhite-12th-generation-cases' },
    { label: 'Kindle Paperwhite Signature Edition (12th Gen)', handle: 'kindle-paperwhite-signature-edition-12th-generation-cases' },
    { label: 'Kindle Paperwhite (11th Gen)', handle: 'kindle-paperwhite-11th-generation-cases' },
    { label: 'Kindle Colorsoft (1st Gen)', handle: 'kindle-colorsoft-1st-generation-cases' },
    { label: 'Kindle Colorsoft Signature Edition (1st Gen)', handle: 'kindle-colorsoft-signature-edition-1st-generation-cases' }
  ];

  function getGenderFilterSuffix() {
    var params = new URLSearchParams(window.location.search);
    var view = params.get('view') || '';
    var isMen = view.indexOf('men') !== -1 || sessionStorage.getItem('gender') === 'men';
    var filterValue = isMen ? 'male,unisex' : 'female,unisex';
    return '?filter.p.m.custom.product_gender_context=' + filterValue;
  }

  function init(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var modelSelect = container.querySelector('[data-model-select]');

    modelSelect.innerHTML = MODELS.map(function (m) {
      return '<option value="' + m.handle + '">' + m.label + '</option>';
    }).join('');

    var pathHandle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var matchingModel = MODELS.find(function (m) { return m.handle === pathHandle; });
    if (matchingModel) modelSelect.value = matchingModel.handle;

    modelSelect.addEventListener('change', function () {
      if (modelSelect.value) {
        window.location.href = '/collections/' + modelSelect.value + getGenderFilterSuffix();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="KindleSelector-"]').forEach(function (el) {
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();